import { Paper, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AppDownloadBannerProps {
  storeUrl: string;
  storeName: string;
  onDismiss: () => void;
}

const AppDownloadBanner = ({ storeUrl, storeName, onDismiss }: AppDownloadBannerProps) => {
  return (
    <Paper
      elevation={2}
      square
      sx={{
        position: 'fixed',
        top: 56, // Below mobile AppBar
        left: 0,
        right: 0,
        zIndex: 1100,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        px: 1,
        gap: 1,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <IconButton
        size="small"
        onClick={onDismiss}
        aria-label="Dismiss"
        sx={{ color: 'text.secondary' }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }} noWrap>
          Live Shuffle is better in the app
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap component="div">
          Free on {storeName}
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="small"
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ flexShrink: 0, mr: 0.5 }}
      >
        Get
      </Button>
    </Paper>
  );
};

export default AppDownloadBanner;
